import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useAnalyticsLogging } from "../../Shared/hooks/useAnalyticsLogging/useAnalyticsLogging";
import { LoginRegisterShell } from "../LoginRegisterShell";
import { RegisterForm } from "./RegisterForm";
export const Register = () => {
    const { logReactPixelPageView, gaPageView } = useAnalyticsLogging();
    useEffect(() => {
        logReactPixelPageView();
        gaPageView('Register', location.pathname);
    }, []);
    return (_jsx(LoginRegisterShell, { children: _jsx(RegisterForm, {}) }));
};
